module.exports = __webpack_public_path__ + "media/icons-lj-styleguide-2025/checkbox-selected-d759fc63.svg";